{
  "version": 1,
  "asset_id": "f6b906c4-320b-4137-b034-793799db7506",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/f6b906c4-320b-4137-b034-793799db7506/sleeve-fitzer-3.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/f6b906c4-320b-4137-b034-793799db7506/sleeve-fitzer-3.jpg",
  "original_filename": "sleeve-fitzer-3.jpg",
  "size": 104178,
  "content_type": "image/jpeg",
  "created_at": "2026-07-14T23:02:51Z"
}
